export default "__VITE_ASSET__D8iXb21r__"